'use strict';

var LOCALE_ARRAY_FIELDS = [
  'months', 'weekdays', 'units', 'numerals', 'placeholders',
  'articles', 'tokens', 'timeMarkers', 'ampm', 'timeSuffixes',
  'parse', 'timeParse', 'timeFrontParse', 'modifiers'
];

module.exports = LOCALE_ARRAY_FIELDS;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/var/LOCALE_ARRAY_FIELDS.js
// module id = 605
// module chunks = 0